import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

const MPageFooter = ({ children, css = "px-4 pt-2 pb-4", position = "fixed", noneFooterGap = false }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef();
  useEffect(() => {
    setHeight(ref?.current?.clientHeight || 0);
  }, [children]);
  useEffect(() => {
    const handlerResize = () => {
      setHeight(ref?.current?.clientHeight || 0);
    };
    window?.addEventListener("resize", handlerResize);
    return () => {
      window?.removeEventListener("resize", handlerResize);
    };
  }, []);
  return <>
    {!noneFooterGap && <>
      <div style={{
        width: "100%",
        minHeight: height,
        zIndex: 1,
      }} />
    </>}
    <div
      ref={ref}
      className={`position-${position} w-100 ${css}`}
      style={{
        bottom: 0,
        zIndex: 2,
      }}
    >
      {children}
    </div>
  </>
};

const mapState = (state) => {
  return {};
};

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(MPageFooter);
